import store from '@/store';
import { creditScoreRepository } from '@/forms/api/repository-factory';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import FIELD_NAMES from '@/forms/constants/field-names';
import { SET_CREDIT_SCORE_STATUS } from '@/lib/constants/mutations';
import dateToAPI from '@/forms/helpers/date-to-api';
import callApi from '@/lib/helpers/call-api';
const creditScoreDateFormat = function(date) {
    var datetoConvert = new Date(date);
    var dobDate = datetoConvert.getDate();
    var dobMonth = datetoConvert.getMonth() + 1;
    var dobYear = datetoConvert.getFullYear();
    var newdobDate = dobDate < 10 ? '0' + '' + dobDate + '' : '' + dobDate + '';
    var newmonthDate = dobMonth < 10 ? '0' + '' + dobMonth + '' : '' + dobMonth + '';

    return newdobDate + newmonthDate + dobYear;
};
const getPayload = () => {
    const { values } = store.state.formData;
    const { appId, cifnumber } = store.state;
    const firstName = getValueByFieldName(values, FIELD_NAMES.firstName);
    const lastName = getValueByFieldName(values, FIELD_NAMES.lastName);
    const dob = dateToAPI(getValueByFieldName(values, FIELD_NAMES.birthDate));
    const maritalStatus = getValueByFieldName(values, FIELD_NAMES.maritalStatus);
    const lineIn = getValueByFieldName(values, FIELD_NAMES.residenceType)
    const length = getValueByFieldName(values, FIELD_NAMES.workAmount)
    let passportExpiryDate, passportNumber;
    if (getValueByFieldName(values, FIELD_NAMES.passportNumber)) {
        passportNumber = getValueByFieldName(values, FIELD_NAMES.passportNumber);
    }
    if (getValueByFieldName(values, FIELD_NAMES.passportExpiryDate)) {
        passportExpiryDate = creditScoreDateFormat(getValueByFieldName(values, FIELD_NAMES.passportExpiryDate));
    }

    return {
        'app-id': appId,
        'cif-number': cifnumber,
        'first-name': firstName,
        'last-name': lastName,
        'full-name': [firstName, lastName].join(' '),
        gender: getValueByFieldName(values, FIELD_NAMES.gender),
        dob,
        maritalStatus,
        'live-in': lineIn,
        nationality: getValueByFieldName(values, FIELD_NAMES.nationality),
        'emirates-id': getValueByFieldName(values, FIELD_NAMES.emiratesID),
        'length': length,
        income: getValueByFieldName(values, FIELD_NAMES.fixedIncome),
        'passport-number': typeof passportNumber !== 'undefined' ? passportNumber : "",
        'passport-expiry': typeof passportExpiryDate !== 'undefined' ? passportExpiryDate : "",
        'previous-passport-number': "",
        'mobile-number': getValueByFieldName(values, FIELD_NAMES.phoneNumber),
        'subject-id': null,

    };
};

export default {
    async creditScoreApproval(currentStep, callbacks) {
        const { form } = currentStep;

        const response = await callApi({
            callbacks,
            form,
            formElement: currentStep,
            apiCall: creditScoreRepository.approval,
            payload: getPayload(),
        });
        const creditScoreStatus = response['status'];
        if (creditScoreStatus) {
            store.commit(SET_CREDIT_SCORE_STATUS, { creditScoreStatus });
        }
        return response.status.toUpperCase() === 'ELIGIBLE';
    },
};